import React, { useState, useEffect } from 'react';
import * as AuthService from '../../services/auth';
import { ContentHeader } from '@components';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
import TableDriverItem from './report/TableDriverItem';
import Modal from 'react-bootstrap/Modal';
import ModalAddDriver from './modal/ModalAddDriver';
import ModalResetPassword from './modal/ModalResetPassword';
import { Button, Tabs, Tab, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CarStatusCalendar from './report/DriverScheduleTable';

export default function Driver() {
  const [data, setData] = useState<any[]>([]);
  const [owner, setOwner] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState('add');
  const [item, setItem] = useState<any>(null);
  const dispatch = useDispatch();
  const [showMd, setShowMd] = useState(false);
  const [showResetMd, setShowResetMd] = useState(false);

  const [key, setKey] = useState('driver-list');

  const handleMdNew = () => {
    setShowMd(true);
    setMode('add');
  };

  useEffect(() => {
    downloadDriver();
    downloadOwner();
    downloadCrWs();
  }, []);

  const toggleModal = (item: any) => {
    setShowMd(!showMd);
    setItem(item);
    setMode('edit');
  };

  const toggleResetModal = (item: any) => {
    setShowResetMd(!showResetMd);
    setItem(item);
  };

  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      if (show.error) toast.error(show.error);
      setShow(show.value);
    } catch (error) { }
  };

  const downloadDriver = async () => {
    try {
      const data = await AuthService.downloadDriver();
      if (data.error) throw 'timeout';
      console.log(data);
      setData(data.result);
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const downloadOwner = async () => {
    try {
      const data = await AuthService.downloadOwner();
      if (data.error) throw 'timeout';
      console.log(data);
      setOwner(data.result);
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const resetDriverWs = async (input: any) => {
    try {
      const data = await AuthService.resetDriverWs(input);
      if (data.error) throw 'timeout';
      toast.success('ดำเนินการเปลี่ยนรหัสผ่านแล้ว');
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const addDriverWs = async (input: any, file: any) => {
    try {
      const data = await AuthService.insertDriverWs(input, file);
      if (data.error) throw 'timeout';
      console.log(data);
      setData(data.result);
      toast.success('ดำเนินการเพิ่มคนขับแล้ว');
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const editDriverWs = async (input: any, file: any) => {
    try {
      console.log(input);
      const data = await AuthService.updateDriverWs(input, file);
      if (data.error) throw 'timeout';
      console.log(data);
      setData(data.result);
      toast.success('ดำเนินการแก้ไขแล้ว');
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const deleteDriverWs = async (input: any) => {
    try {
      const data = await AuthService.deleteDriverWs(input);
      if (data.error) throw 'timeout';
      console.log(data);
      setData(data.result);
      toast.success('ดำเนินการลบแล้ว');
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  return (
    <div>
      <Modal show={showMd} size={'lg'} onHide={() => setShowMd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มคนขับรถ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddDriver
            owner={owner}
            item={item}
            mode={mode}
            onAdd={(input: any, file: any) => {
              addDriverWs(input, file);
              setShowMd(false);
            }}
            onEdit={(input: any, file: any) => {
              editDriverWs(input, file);
              setShowMd(false);
            }}
            onDelete={(input: any, file: any) => {
              deleteDriverWs(input);
              setShowMd(false);
            }}
          ></ModalAddDriver>
        </Modal.Body>
      </Modal>
      <Modal show={showResetMd} onHide={() => setShowResetMd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ตั้งรหัสผ่านใหม่ให้คนขับรถ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalResetPassword
            item={item}
            onReset={(card_id: any, password: any) => {
              resetDriverWs({ card_id: card_id, password: password });
              setShowResetMd(false);
            }}
          ></ModalResetPassword>
        </Modal.Body>
      </Modal>
      <ContentHeader title="Driver" />{' '}
      <section className="content">
        <div className="container-fluid">
          <Tabs
            id="driver-main-tabs"
            activeKey={key}
            onSelect={(k: any) => setKey(k)}
            className="custom-tabs"
            justified
          >
            <Tab
              eventKey="driver-list"
              title={
                <span>
                  <i className="fas fa-id-card me-2"></i> รายชื่อคนขับรถบริการ
                </span>
              }
            >
              <div className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 text-muted" style={{ fontWeight: 600 }}>
                    จัดการข้อมูลคนขับรถบริการ
                  </h5>
                  <Button
                    disabled={!show}
                    variant="primary"
                    className="shadow-sm"
                    style={{ borderRadius: '8px' }}
                    onClick={handleMdNew}
                  >
                    <i className="fas fa-plus me-2"></i> เพิ่มคนขับรถ
                  </Button>
                </div>

                <TableDriverItem
                  onToggle={toggleModal}
                  onResetToggle={toggleResetModal}
                  cr={show}
                  show={true}
                  items={data}
                  onPageChange={setPageHandle}
                  page={page}
                />
              </div>
            </Tab>

            {/* Tab ที่ 2: ตรวจสอบสถานะรถบริการ (หน้าที่กำลังจะทำเพิ่ม) */}
            {/* Tab ที่ 2: ตรวจสอบสถานะรถบริการ (หน้าที่กำลังจะทำเพิ่ม) */}
            <Tab
              eventKey="service-status"
              title={
                <span>
                  <i className="fas fa-car-side me-2"></i> ตรวจสอบสถานะรถบริการ
                </span>
              }
            >
              <div className="p-3">
                {show ? (
                  // 🟢 ถ้าเป็น CR ให้เปิดปฏิทินสถานะรถใช้งานตามปกติ
                  <CarStatusCalendar />
                ) : (
                  // 🔴 ถ้าไม่ใช่ CR ให้ขึ้นกล่องข้อความเตือนล็อกสิทธิ์ตรงกลางแท็บ
                  <div
                    className="overlay dark"
                    style={{
                      minHeight: '300px',
                      backgroundColor: 'rgba(0,0,0,0.75)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '8px'
                    }}
                  >
                    <span style={{ color: 'white', fontSize: 30, fontWeight: 600 }}>
                      <i className="fas fa-lock me-2"></i> CR ONLY
                    </span>
                  </div>
                )}
              </div>
            </Tab>
          </Tabs>
        </div>
      </section>
    </div>
  );
}
